import { theme } from '@fiverr-private/theme';
import { brandPageTheme } from '../constants';

export type ResolutionsBasedKeys = `screen and (min-width: ${number}px)`;

export const endSizesForCarousel: Record<
    ResolutionsBasedKeys,
    {
        width: number;
        height: number;
        notFirstWidth: number;
        notFirstHeight: number;
    }
> = {
    [theme.breakpoints.lg]: {
        width: 302,
        height: 368,
        notFirstWidth: 215,
        notFirstHeight: 260,
    },
    [theme.breakpoints.xl]: {
        width: 374,
        height: 458,
        notFirstWidth: 268,
        notFirstHeight: 324,
    },
    [brandPageTheme.breakpoints.xxl]: {
        width: 505,
        height: 648,
        notFirstWidth: 362,
        notFirstHeight: 442,
    },
    [brandPageTheme.breakpoints.xxxl]: {
        width: 646,
        height: 790,
        notFirstWidth: 462,
        notFirstHeight: 560,
    },
};

export const paddingsForCarousel: Record<
    ResolutionsBasedKeys,
    {
        paddingTop: number;
        paddingLeft: number;
        gap: number;
    }
> = {
    [theme.breakpoints.lg]: {
        paddingTop: 18,
        paddingLeft: 50,
        gap: 14,
    },
    [theme.breakpoints.xl]: {
        paddingTop: 22,
        paddingLeft: 34,
        gap: 20,
    },
    [brandPageTheme.breakpoints.xxl]: {
        paddingTop: 16,
        paddingLeft: 72,
        gap: 28,
    },
    [brandPageTheme.breakpoints.xxxl]: {
        paddingTop: 1,
        paddingLeft: 164,
        gap: 36,
    },
};
